import ParameterValue from './ParameterValue';
import PredictGroup from "./PredictGroup";
import PredictValue from './PredictValue';
import PointGroup from './PointGroup';
import ParameterGroup from './ParameterGroup';
import { GetWapiCoordinateOrder, WapiCoordinateOrder } from '../../constants/index.js'

export default class WapiForecastMessageViewModel {
  constructor() {
    this.points = [];
    this.parameters = [];
    this.ref_time = new Date();
    this.predicts = [];
    this.tile_size = {};
    this.values = [];
    this.parameterValues = [];
    this.predictGroups = [];
    this.pointGroups = [];
  }

  map(wapiForecastMessage, coordinateOrder = [1, 0]) {
    const wapiCoordinateOrder = GetWapiCoordinateOrder(coordinateOrder);
    this.points = wapiForecastMessage.points;
    this.parameters = wapiForecastMessage.parameters;
    this.ref_time = wapiForecastMessage.ref_time;
    this.predicts = wapiForecastMessage.predicts;
    this.tile_size = wapiForecastMessage.tile_size;
    this.values = wapiForecastMessage.values;
    let pointIndex = 0;
    for (let p = 0; p < this.parameters.length; p++) {
      const predict_start = this.predicts.length * p;
      const predict_end = this.predicts.length * (p + 1);

      for (let predict_index = predict_start; predict_index < predict_end; predict_index++) {
        const point_start = this.points.length * predict_index;
        const point_end = this.points.length * (predict_index + 1);

        for (let point_index = point_start; point_index < point_end; point_index++) {
          const value = this.values[point_index];
          const parameter = this.parameters[p];
          const predict = this.predicts[predict_index - predict_start];
          const point = this.points[point_index - point_start];
          let pointGroup;

          if (wapiCoordinateOrder === WapiCoordinateOrder.LatLon) {
            pointGroup = this.pointGroups.find(x => x.latitude === point.x && x.longitude === point.y);
          } else {
            pointGroup = this.pointGroups.find(x => x.latitude === point.y && x.longitude === point.x);
          }

          if (!pointGroup) {

            if (wapiCoordinateOrder === WapiCoordinateOrder.LatLon) {
              pointGroup = new PointGroup(point.x, point.y)
            } else {
              pointGroup = new PointGroup(point.y, point.x)
            }

            pointGroup.id = pointIndex++;
            this.pointGroups.push(pointGroup);
          }

          let predictGroup = pointGroup.predictGroups.find(x => x.predict == predict);
          if (predictGroup) {
            predictGroup.values.push(new ParameterValue(parameter.code, value, parameter.level_type, parameter.level, parameter.sname, parameter.pname, parameter.unit));
          } else {
            predictGroup = new PredictGroup(predict);
            pointGroup.predictGroups.push(predictGroup);
            predictGroup.values.push(new ParameterValue(parameter.code, value, parameter.level_type, parameter.level, parameter.sname, parameter.pname, parameter.unit));
          }

          let parameterGroup = pointGroup.parameterGroups.find(x => x.code == parameter.sname);
          if (parameterGroup) {
            parameterGroup.values.push(new PredictValue(predict, value));
          } else {
            parameterGroup = new ParameterGroup(parameter.sname);
            pointGroup.parameterGroups.push(parameterGroup);
            parameterGroup.values.push(new PredictValue(predict, value));
          }
        }
      }
    }

    return this;
  }
}
